/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApplicationType,
    ApplicationTypeFromJSON,
    ApplicationTypeFromJSONTyped,
    ApplicationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApplicationTypeDetails
 */
export interface ApplicationTypeDetails {
    /**
     * 
     * @type {number}
     * @memberof ApplicationTypeDetails
     */
    id?: number;
    /**
     * 
     * @type {ApplicationType}
     * @memberof ApplicationTypeDetails
     */
    applicationType?: ApplicationType;
}

export function ApplicationTypeDetailsFromJSON(json: any): ApplicationTypeDetails {
    return ApplicationTypeDetailsFromJSONTyped(json, false);
}

export function ApplicationTypeDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationTypeDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'applicationType': !exists(json, 'applicationType') ? undefined : ApplicationTypeFromJSON(json['applicationType']),
    };
}

export function ApplicationTypeDetailsToJSON(value?: ApplicationTypeDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'applicationType': ApplicationTypeToJSON(value.applicationType),
    };
}


